import appModule from '../../app.module';

class AuthenticationService {
    constructor(
        __env,
        $cookies,
        $http,
        $location,
        $q,
        $sessionStorage,
        $state,
        $window,
        cookieConstants,
        serviceRoot,
        stateConstants,
        sessionStorageConstants,
        sessionTypeConstants
    ) {
        this.__env = __env;
        this.$cookies = $cookies;
        this.$http = $http;
        this.$location = $location;
        this.$q = $q;
        this.$sessionStorage = $sessionStorage;
        this.$state = $state;
        this.$window = $window;
        this.cookieConstants = cookieConstants;
        this.serviceRoot = serviceRoot;

        this.promiseCache = {};
        this.cloudToken = null;
        this.stateConstants = stateConstants;
        this.sessionStorageConstants = sessionStorageConstants;
        this.sessionTypeConstants = sessionTypeConstants;
    }

    setToken(token) {
        this.$window.sessionStorage.token = token;

        if (token) {
            this.cloudToken = {
                tokenKey: token
            };
        }
    }

    getToken() {
        const deferred = this.$q.defer();

        let promise = this.$q.resolve(this.cloudToken);

        if (!this.cloudToken) {
            promise = this.$http
                .get(`${this.__env.cloudApiUrl}/api/v1/appspace/token`, {
                    withCredentials: true
                })
                .then(
                    response => {
                        if (!response.data.TokenKey) {
                            return null;
                        }

                        this.cloudToken = {
                            tokenKey: response.data.TokenKey
                        };

                        return this.cloudToken;
                    },
                    response => {
                        this.serviceRoot.errorStatusFilter(response);
                        throw response.data;
                    }
                );
        }

        promise.then(cloudToken => {
            if (!cloudToken) {
                deferred.resolve(null);
                return;
            }

            deferred.resolve(cloudToken.tokenKey);
        }, deferred.reject);

        return deferred.promise;
    }

    verifyToken() {
        const promiseId = 'verifyToken';
        if (this.promiseCache[promiseId]) {
            return this.promiseCache[promiseId].promise;
        }

        const deferred = this.$q.defer();
        this.promiseCache[promiseId] = deferred;

        this.getToken().then(token => {
            if (!token) {
                deferred.reject();
                return;
            }

            this.$http
                .get(
                    `${
                        this.__env.cloudApiUrl
                    }/api/v1/appspace/token/${token}?includeInstanceAccess=true`
                )
                .then(
                    response => {
                        if (!response.data || !response.data.InstanceAccess) {
                            deferred.reject(response.data);
                            return;
                        }

                        this.$window.sessionStorage.token = token;
                        this.$sessionStorage.accountGuid =
                            response.data.Account.Guid;
                        this.$sessionStorage.userGuid = response.data.User.Guid;
                        deferred.resolve(response.data);
                    },
                    response => {
                        this.serviceRoot.errorStatusFilter(response);
                        deferred.reject(response.data);
                        delete this.promiseCache[promiseId];
                    }
                );
        });

        return deferred.promise;
    }

    logout(clearCookie, targetState) {
        let supportedState =
            targetState &&
            (targetState.name !==
                this.stateConstants.cloud.urlVerification.name &&
                targetState.name !==
                    this.stateConstants.cloud.registration.name);
        let currentUrl = supportedState
            ? this.$state.href(targetState.name, {}, { absolute: true })
            : this.$window.location.href;

        currentUrl = this.$window
            .encodeURIComponent(currentUrl)
            .replace(/#/g, '%23');

        const sessionType = this.$sessionStorage[
            this.sessionStorageConstants.sessionType
        ];

        this.clearSession(clearCookie);

        if (sessionType === this.sessionTypeConstants.guest) {
            this.$window.location.href = '/#!/billing/guest';
            return;
        }

        this.$window.location.href = `${
            this.__env.cloudUrl
        }/cs/#!/logout?message=account&mode=account&ReturnUrl=${currentUrl}`;
    }

    clearSession(clearCookie) {
        if (clearCookie) {
            delete this.$window.sessionStorage.token;
        }

        delete this.$sessionStorage.token_billing;
        delete this.$sessionStorage.token_customersupport;
        delete this.$sessionStorage.accountGuid;
        delete this.$sessionStorage.userGuid;
        delete this.$sessionStorage.session_type;
    }
}

export default appModule.service(
    'authenticationService',
    AuthenticationService
);



// WEBPACK FOOTER //
// ./shared/services/authenticationService.service.js